export const filterLaunchAreas = <T extends { Id: string }>(
  launchAreas: T[],
  selectedIds: string[] | undefined
): T[] =>
  selectedIds
    ? launchAreas.filter((area) => selectedIds.includes(area.Id))
    : launchAreas;
